<template>
  <div class="az-banana-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="97"
      height="97"
      viewBox="0 0 97 97"
      fill="none"
    >
      <g filter="url(#filter0_d_15_1841)">
        <path
          d="M86.9462 60.2439C86.7273 60.1632 86.5401 60.0176 86.4111 59.8277C86.311 59.6002 86.2594 59.3554 86.2595 59.1079C86.2738 58.8238 86.1879 58.5434 86.016 58.3131C85.8441 58.0829 85.5964 57.9166 85.3141 57.8419C85.1238 57.7823 84.9303 57.7331 84.7344 57.6945H84.5738V57.7465C82.1298 57.4331 79.648 57.5417 77.2428 58.0674C70.3131 59.3681 56.7926 60.9029 46.2865 57.2002C25.6758 49.8642 20.9846 26.0871 25.0247 23.2949C29.0648 20.5027 13.6893 12.5076 16.784 22.6272C17.4796 29.2088 7.61573 32.9202 8.63244 43.8289C10.4162 62.299 25.9968 71.829 39.0714 76.4508C55.8294 82.3908 81.2383 78.9395 87.3921 62.6372L87.4456 62.5071C88.0521 61.007 87.5794 60.5821 86.9462 60.2439Z"
          fill="#FECB00"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_15_1841"
          x="2.55884"
          y="14.6523"
          width="91.1677"
          height="73.5156"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_1841"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_1841"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </div>
</template>
